import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import { mapActions } from "vuex";
import { captcha } from "@/api/user";
export default {
  name: "Login",
  data: function data() {
    var checkUsername = function checkUsername(rule, value, callback) {
      if (value.length < 5 || value.length > 20) {
        return callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    var checkPassword = function checkPassword(rule, value, callback) {
      if (value.length < 6 || value.length > 20) {
        return callback(new Error("请输入正确的密码"));
      } else {
        callback();
      }
    };
    return {
      title: process.env.VUE_APP_PROJECT_NAME,
      curYear: 0,
      lock: "lock",
      loginForm: {
        username: "",
        password: "",
        captcha: "",
        captchaId: ""
      },
      rules: {
        username: [{
          validator: checkUsername,
          trigger: "blur"
        }],
        password: [{
          validator: checkPassword,
          trigger: "blur"
        }]
      },
      logVerify: "",
      picPath: ""
    };
  },
  created: function created() {
    this.loginVefify();
    this.curYear = new Date().getFullYear();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("user", ["LoginIn"])), {}, {
    login: function login() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.LoginIn(_this.loginForm);
            case 2:
              if (_context.sent) {
                _context.next = 4;
                break;
              }
              _this.loginVefify();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    submitForm: function submitForm() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.$refs.loginForm.validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(v) {
                  var flag;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!v) {
                          _context2.next = 7;
                          break;
                        }
                        _context2.next = 3;
                        return _this2.login();
                      case 3:
                        flag = _context2.sent;
                        if (!flag) {
                          _this2.loginVefify();
                        }
                        _context2.next = 10;
                        break;
                      case 7:
                        _this2.$message({
                          type: "error",
                          message: "请正确填写登录信息",
                          showClose: true
                        });
                        _this2.loginVefify();
                        return _context2.abrupt("return", false);
                      case 10:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changeLock: function changeLock() {
      this.lock === "lock" ? this.lock = "unlock" : this.lock = "lock";
    },
    loginVefify: function loginVefify() {
      var _this3 = this;
      captcha({}).then(function (ele) {
        _this3.picPath = ele.data.picPath;
        _this3.loginForm.captchaId = ele.data.captchaId;
      });
    }
  })
};